var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datas && _vm.currentRouteName != 'operation')?_c('div',[(_vm.datas.host === 'allopneu.promo.dev')?_c('Allopneus'):_vm._e(),(_vm.datas.host === 'promoprofilplus.fr')?_c('Profilplus'):_c('Classic')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }